import React from "react";

const Exchanges = () => {
    return (
        <div>
            <p>
                Exchanges
            </p>
        </div>
    )
}

export default Exchanges; 